import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FiltrosCustosService } from '../../../../filters/filtros-custos.service';
import { IntegradorService } from '../../../../services/integrador.service';
import { ToastService } from '../../../../services/toast.service';
import { Instancia } from '../../../../types/Instancia.type';
import { PeriodoLiberado } from '../../../../types/PeriodoLiberado.type';
import { Processamento } from '../../../../types/Processamento.type';
import { Processo } from '../../../../types/Processo.type';
import { RequisicaoIntegracao } from '../../../../types/RequisicaoIntegracao.type';

@Component({
  selector: 'app-painelcustos',
  templateUrl: './painelcustos.component.html',
  styleUrl: './painelcustos.component.css',
  providers: [DatePipe]
})
export class PainelcustosComponent {
  rangeDates!: string;
  instancias: Instancia[] = [
    { id: 'VALE', nome: 'VALE' },
    { id: 'UCP', nome: 'UCP' },
    { id: 'UVP', nome: 'UVP' },
  ];
  instanciaSelecionada!: string;
  loading: boolean = false;
  loadingInteg: boolean = false;
  loadingSincronizar: boolean = false;
  processamentos: Processamento[] = []
  periodosLiberados: PeriodoLiberado[] = []
  periodoSelecionado!: PeriodoLiberado
  totalRecords: number = 0;
  loadingProcessamento: boolean = false;

  processos: Processo[] = [
    { id: 'DESPESA', nome: 'Despesas Gerais'},
    { id: 'CONSUMO', nome: 'Consumo'},
    { id: 'DEPRECIACAO', nome: 'Depreciação'},
    { id: 'HORAMANUTENCAO', nome: 'Horas Manutenção'}
  ]

  processosSelecionados!: any;

  constructor(private filtrosCusto: FiltrosCustosService, private datePipe: DatePipe, private integradorService: IntegradorService, private toastService: ToastService){}

  onDateChange(event: any){
    this.filtrosCusto.alteraDataInicio(this.getDataPipeTransForm(this.rangeDates[0]));
    this.filtrosCusto.alteraDataFim(this.getDataPipeTransForm(this.rangeDates[1]));
  }

  onInstanciaChange(event: any){
    this.filtrosCusto.alteraInstancias(this.instanciaSelecionada);
  }

  getDataPipeTransForm(data: string): string | "" {
    return this.datePipe.transform( data,'dd/MM/yyyy') || "";
  }

  carregaPeriodos(event: any){
    console.log(event.value);

    this.integradorService.getPeriodosLiberadosCustos(event.value).subscribe(
      {
        next: (data) => {
          this.periodosLiberados = data
        },
        error: (error) => {
          this.toastService.erro("Erro", "Erro: " + error.error)
        }
      }
    )
  }

  carregaProcessamento(event: any){
    this.loadingProcessamento = true

    const sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';

    this.integradorService.getProcessamentos(event.first / event.rows,
      event.rows,
      event.sortField,
      sortDirection,
      "DEPRECIACAO,CONSUMO,DESPESA,HORAMANUTENCAO").subscribe(
        (data) => {
          this.processamentos = data.content;
          this.totalRecords = data.totalElements;
          this.loading = false;
        }
      )
  }

  requisitaIntegracao(){

    let requisicao: RequisicaoIntegracao = {
      instancia: this.instanciaSelecionada,
      periodo: this.periodoSelecionado,
      processos: this.processosSelecionados,
      usuario: localStorage.getItem("cdUsuarioErp") || ""
    }

    this.integradorService.postRequisicaoCustos(requisicao).subscribe({
      next: (data) => {
        this.toastService.sucesso("OK","Solicitação realizada, aguarde a finalização do processamento")
      },
      error: (error) => {
        console.log(error);
        this.toastService.erro("NOK","Erro: " + error.error.message)
      }
    })

    console.log(requisicao);

  }
}
